import { Row, CardBody } from "../App.styles";
import { SidebarLayout } from "../common";
import { Shimmer } from "../common/Loading.styles";
import NpcItemPlaceholder from "./NpcItemPlaceholder";

const Panel = () => (
    <CardBody className="card p-4">
        <Shimmer dark type="title" />
        <Shimmer dark />
    </CardBody>
);

const NpcPlaceholder = () => {
    return (
        <>
            <Row>
                <SidebarLayout
                    panel={<Panel />}
                >
                    <div>
                        <ul className="list-unstyled">
                            <div>
                                <NpcItemPlaceholder />
                                <NpcItemPlaceholder />
                                <NpcItemPlaceholder />
                                <NpcItemPlaceholder />
                                <NpcItemPlaceholder />
                            </div>
                        </ul>
                    </div>
                </SidebarLayout>
            </Row>
        </>
    );
};

export default NpcPlaceholder;
